export const WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_1 = 'WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_1';

export const WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_2 = 'WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_2';

export const WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_3 = 'WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_3';

export const WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_4 = 'WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_4';

export const WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_5 = 'WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_5';

export const WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_6 = 'WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_6';

export const WE_SPIN_RESOURCE_KEY_LOBBY_CARD_IMAGE = 'WE_SPIN_RESOURCE_KEY_LOBBY_CARD_IMAGE';

export const WE_SPIN_RESOURCE_KEY_BONUS_HUNT_IMAGE = 'WE_SPIN_RESOURCE_KEY_BONUS_HUNT_IMAGE';

export const RESOURCE_KEYS = [
	WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_1,
	WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_2,
	WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_3,
	WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_4,
	WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_5,
	WE_SPIN_RESOURCE_KEY_ONBOARDING_IMAGE_6,
	WE_SPIN_RESOURCE_KEY_LOBBY_CARD_IMAGE,
	WE_SPIN_RESOURCE_KEY_BONUS_HUNT_IMAGE
];
